module.exports = __webpack_public_path__ + "static/media/heycar_cover.21435920.png";